import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import Assessment from './Assessment.component';
import AssessmentAccessGuard from './AssessmentAccessGuard';

const AssessmentTrainingPage: React.FC = () => {
  const processTypeStringId = AssessmentSessionProcessTypeId.Training.toString();
  const processTypeId = parseInt(processTypeStringId) as AssessmentSessionProcessTypeId;

  return (
    <AssessmentAccessGuard processTypeStringId={processTypeStringId}>
      <Assessment processTypeId={processTypeId} processTypeStringId={processTypeStringId} />
    </AssessmentAccessGuard>
  );
};

export default AssessmentTrainingPage;
